export const SET_USERS                              = 'SET_USERS';
export const SET_EXECUTORS_LOADING                  = 'SET_EXECUTORS_LOADING';
export const SET_EXECUTORS                          = 'SET_EXECUTORS';
export const SET_USERS_PAGINATION_AMOUNT            = 'SET_USERS_PAGINATION_AMOUNT';
export const SET_SELECTED_USER                      = 'SET_SELECTED_USER';
export const SET_USERS_LIMIT                        = 'SET_USERS_LIMIT';
